import classNames from "classnames";
import "react-image-crop/dist/ReactCrop.css";
import JobCreator from "./JobCreator";
import { JobGetResponse } from "@/types/job";
import Image from "next/image";
import { toJobCreatorConfigFromJob } from "./utils";
import { PublicPageZip } from "@/utils/page";
import Section from "@/components/Section/Section";
import SectionContainer from "@/components/Section/SectionContainer";
import { getCombinedJobHistory } from "@/utils/job";

interface Section01Props extends React.HTMLAttributes<HTMLElement> {
  job?: JobGetResponse;
  page: any;
  section: any;
}

const JobCreatorSection = ({ className, job, page, section, ...props }: Section01Props) => {
  const combinedJobHistory = getCombinedJobHistory({
    job,
  }).filter((item) => {
    return item.history !== undefined && item.history.error_log_id === undefined;
  });

  return (
    <Section className={classNames("bg-vpBlue-200", className)} section={section} {...props}>
      <SectionContainer className="relative z-10 lg:max-w-5xl" section={section}>
        <div className="flex flex-col gap-10">
          {section?.Title && (
            <h1
              className={classNames("text-balance text-center text-6xl font-bold", section?.TitleElement?.ClassName)}
              id={section?.TitleElement?.HtmlId}
              style={section?.TitleElement?.Style}
              {...section?.TitleElement?.Rest}
            >
              {section?.Title}
            </h1>
          )}
          {section?.Subtitle && (
            <div
              className={classNames("text-balance text-center text-2xl", section?.SubtitleElement?.ClassName)}
              id={section?.SubtitleElement?.HtmlId}
              style={section?.SubtitleElement?.Style}
              {...section?.SubtitleElement?.Rest}
            >
              {section?.Subtitle}
            </div>
          )}
        </div>
        <JobCreator
          cropDisabled={job !== undefined}
          defaultImageError={job !== undefined && combinedJobHistory.length === 0 ? "error" : ""}
          defaultJobCreatorConfig={job ? toJobCreatorConfigFromJob({ job }) : undefined}
          page={page}
          section={section}
        />
      </SectionContainer>
      <Image
        alt="Clouds background image"
        className="absolute left-0 top-0 z-0 w-full opacity-70"
        height="100"
        priority
        src="/_public-pages-service/clouds.svg"
        width="100"
      />
    </Section>
  );
};

export default JobCreatorSection;
